export default {
  'common.balance.title': 'Balance',
  'common.balance.coinName': 'Coin',
  'common.balance.startName': 'Star',
  'common.search.noResult': 'No results...',
  'common.search.search': 'Search...',
  'common.form.required': 'This field is required',

  'header.user.colorSchemeDark': 'Dark',
  'header.user.colorSchemeLight': 'Light',
  'header.user.logOut': 'Logout',
  'header.user.settings': 'Settings',

  'profile.settings': 'Profile settings',
  'profile.selectRegion': 'Select your region',
  'profile.regionSelectionNotice': 'Please select your correct region. This CANNOT be changed later',
  'profile.regionSelectionWarning': 'This CANNOT be changed later',
  'profile.save': 'Save',
  'profile.saveSuccess': 'Your profile has been saved successfully',

  'theme.settings': 'Theme settings',
  'theme.view': 'Theme list',
  'theme.saveAsNew': 'Or save as new theme',
  'theme.save': 'Save changes',
  'theme.placeholder': 'Theme name',
  'theme.noThemeSelected': 'No theme selected. You may add a new theme or select an existing one',

  'data.saveSuccess': 'Data saved successfully',
  'data.deleteSuccess': 'Deleted successfully',

  // Free Fire Companion translations
  'ff.brand': 'Free Fire Companion',

  // Navigation
  'ff.nav.hot': 'Hot',
  'ff.nav.items': 'Items',
  'ff.nav.outfits': 'Outfits',
  'ff.nav.guns': 'Guns',
  'ff.nav.collections': 'Collections',
  'ff.nav.collectibility': 'Collectibility',
  'ff.nav.tools': 'Tools',
  'ff.nav.profile': 'Profile',
  'ff.nav.skillCombos': 'Skill Combos',
  'ff.nav.more': 'More',
  'ff.nav.playstyles': 'Playstyles',

  // Tabs
  'ff.tabs.mostLoved': 'Most Loved',
  'ff.tabs.recent': 'Recent',
  'ff.tabs.hot': 'Hot',
  'ff.tabs.rank': 'Popularity',
  'ff.tabs.trending': 'Trending',
  'ff.tabs.wishlist': 'Favored',
  'ff.tabs.like7d': 'Hot 7D',
  'ff.tabs.like30d': 'Hot 30D',

  // Rarity
  'ff.rarity.mythic': 'Mythic',
  'ff.rarity.legendary': 'Legendary',
  'ff.rarity.epic': 'Epic',
  'ff.rarity.rare': 'Rare',
  'ff.rarity.common': 'Common',

  'ff.popularity.title': 'Popularity',

  // Actions
  'ff.action.like': 'Like',
  'ff.action.favorite': 'Favorite',
  'ff.action.viewDetails': 'View Details',
  'ff.action.share': 'Share',
  'ff.action.close': 'Close',

  // Search & Filter
  'ff.search.placeholder': 'Search items...',
  'ff.search.filterByRarity': 'Filter by Rarity',
  'ff.search.filterByCategory': 'Filter by Category',
  'ff.search.filterByGenre': 'Filter by Genre',
  'ff.search.allCategories': 'All Categories',
  'ff.search.allRarities': 'All Rarities',
  'ff.search.allGenres': 'All Genres',
  'ff.search.results': 'results',

  // Profile
  'ff.profile.level': 'Level',
  'ff.profile.favorites': 'Favorites',
  'ff.profile.statistics': 'Statistics',
  'ff.profile.totalLikes': 'Total Likes',
  'ff.profile.itemsCollected': 'Items Collected',

  // Event
  'ff.event.featured': 'Featured Event',
  'ff.event.endsIn': 'Ends in',
  'ff.event.viewEvent': 'View Event',

  // Tools
  'ff.tools.sensitivityCalc': 'Sensitivity Calculator',
  'ff.tools.sensitivityCalcDesc': 'Find your perfect aim sensitivity settings',
  'ff.tools.damageCalc': 'Damage Calculator',
  'ff.tools.damageCalcDesc': 'Calculate weapon damage and compare stats',
  'ff.tools.dropCalc': 'Drop Calculator',
  'ff.tools.dropCalcDesc': 'Find the best loot drop locations',

  // Tool Pages
  'ff.tools.marketplace': 'Marketplace',
  'ff.tools.marketplace.search': 'Search marketplace...',
  'ff.tools.marketplace.seller': 'Seller',
  'ff.tools.marketplace.buy': 'Buy',

  'ff.tools.tactical': 'Tactical Map',
  'ff.tools.tactical.search': 'Search drop spots...',
  'ff.tools.tactical.map': 'Map',
  'ff.tools.tactical.rank': 'Rank',
  'ff.tools.tactical.landingRate': 'Landing %',

  'ff.tools.combo': 'Character Combo Stats',
  'ff.tools.combo.role': 'Role',
  'ff.tools.combo.winRate': 'Win Rate',
  'ff.tools.combo.pickRate': 'Pick Rate',
  'ff.tools.combo.sample': 'Sample',

  'ff.tools.gunSkins': 'Gun Skin List',
  'ff.tools.gunSkins.class': 'Class',
  'ff.tools.gunSkins.weapon': 'Weapon',
  'ff.tools.gunSkins.equipRate': 'Equip Rate',

  // Item Details
  'ff.item.stats': 'Stats',
  'ff.item.description': 'Description',
  'ff.item.relatedItems': 'Related Items',
  'ff.item.likes': 'likes',

  // Collections
  'ff.collections.progress': 'Progress',
  'ff.collections.complete': 'Complete',
  'ff.collections.items': 'items',
  'ff.collections.skill': 'Skill',
  'ff.collections.cooldown': 'Cooldown',
  'ff.collections.skillType.active': 'Active',
  'ff.collections.skillType.passive': 'Passive',

  'ff.list.noItems': 'No items found',
  'ff.profile.title': 'Profile',
  'ff.profile.primeLevel': 'Prime Level',
  'ff.profile.collections': 'Collections',
  'ff.profile.currentSeason': 'Current Season',
  'ff.profile.noData': 'No profile data available',

  'ff.item.stats.damage': 'Damage',
  'ff.item.stats.accuracy': 'Accuracy',
  'ff.item.stats.range': 'Range',
  'ff.item.stats.speed': 'Rate of Fire',
  'ff.item.stats.reload': 'Reload',
  'ff.item.stats.cartridge': 'Cartridge',
  'ff.item.stats.biteArmor': 'Bite Armor',
  'ff.item.stats.playerSpeedFactor': 'Movement Speed',

  // Shortened stat labels for item cards
  'ff.item.stats.short.damage': 'DMG',
  'ff.item.stats.short.accuracy': 'ACC',
  'ff.item.stats.short.range': 'RNG',
  'ff.item.stats.short.speed': 'ROF',
  'ff.item.stats.short.reload': 'RLD',
  'ff.item.stats.short.cartridge': 'MAG',
  'ff.item.stats.short.biteArmor': 'PEN',
  'ff.item.stats.short.playerSpeedFactor': 'MOV',

  'ff.action.removeFromCompare': 'Remove from compare',
  'ff.action.compareListFull': 'Compare list full (max 3)',
  'ff.action.addToCompare': 'Add to compare',
  'ff.action.compareHint': 'Please add 1 more gun to compare',

  'ff.list.noMore': 'No more items',
  'ff.item.setContents': 'Set Contents',
  'ff.item.weaponStats': 'Weapon Stats',

  'ff.pageNotFound.title': 'Page not found',
  'ff.pageNotFound.backToHome': 'Back to home',

  'ff.popularity.among': 'AMONG',
  'ff.popularity.allItems': 'ALL ITEMS',

  'ff.filter.title': 'Filters',
  'ff.filter.all': 'All',
  'ff.filter.allGenres': 'All Genres',
  'ff.filter.allWeapons': 'All Weapons',

  'ff.tags.powerType': 'Power up',

  'ff.item.owned': 'Owned',

  'ff.search.filterByWeapon': 'Filter by Weapon',
  'ff.search.allWeapons': 'All Weapons',

  // Collectibility
  'ff.collectibility.title': 'Free Fire Collectibility',
  'ff.collectibility.outfits': 'Outfits',
  'ff.collectibility.gunSkins': 'Gun Skins',
  'ff.collectibility.collections': 'Collections',
  'ff.collectibility.owned': 'Owned',
  'ff.collectibility.points': 'Points',
  'ff.collectibility.uid': 'Uid',
  'ff.collectibility.name': 'Name',
  'ff.collectibility.score': 'Points',
  'ff.collectibility.back': 'Back',
  'ff.collectibility.detail.category': 'Category',
  'ff.collectibility.detail.itemOwned': 'Items Owned',
  'ff.collectibility.detail.pointScore': 'Points',
  'ff.collectibility.rank': 'Rank',

  // Collectibity (wardrobe page)
  'ff.collectibity.title': 'Your Wardrobe',
  'ff.collectibity.collectorProfile': 'Collector Profile',
  'ff.collectibity.totalItems': 'Total Items',
  'ff.collectibity.totalValue': 'Total Value',
  'ff.collectibity.rankLabel': 'Rank',
  'ff.collectibity.rankDetails': 'Rank Details',
  'ff.collectibity.yourScore': 'Your Score',
  'ff.collectibity.filterBtn': 'Filter',
  'ff.collectibity.viewItems': 'View Items',
  'ff.collectibity.category.collection': 'Collection',
  'ff.collectibity.category.fashion': 'Fashion',
  'ff.collectibity.category.guns': 'Guns',
  'ff.collectibity.sub.exhibition': 'Exhibition',
  'ff.collectibity.sub.activity': 'Activity',
  'ff.collectibity.sub.event': 'Event',
  'ff.collectibity.sub.ranking': 'Ranking',
  'ff.collectibity.sub.shirt': 'Shirt',
  'ff.collectibity.sub.swimwear': 'Swimwear',
  'ff.collectibity.sub.pants': 'Pants',
  'ff.collectibity.sub.shoes': 'Shoes',
  'ff.collectibity.sub.head': 'Headwear',
  'ff.collectibity.sub.mask': 'Mask',
  'ff.collectibity.sub.facepaint': 'Face Paint',
  'ff.collectibity.sub.bundle': 'Bundle',
  'ff.collectibity.sub.assault': 'Assault Rifle',
  'ff.collectibity.sub.shotgun': 'Shotgun',
  'ff.collectibity.sub.smg': 'SMG',
  'ff.collectibity.sub.sniper': 'Sniper',
  'ff.collectibity.sub.lmg': 'LMG',
  'ff.collectibity.sub.marksman': 'Marksman',
  'ff.collectibity.sub.launcher': 'Launcher',
  'ff.collectibity.sub.pistol': 'Pistol',
  'ff.collectibity.maxRankReached': 'Max rank reached',
  'ff.collectibity.needMore': 'Need',
  'ff.collectibity.moreToReach': 'more to reach',
  'ff.collectibity.yourRank': 'Your Rank',
  'ff.collectibity.viewDetail': 'View Detail',
  'ff.collectibity.friends': 'Friends',
  'ff.collectibity.server': 'Server',
  'ff.collectibity.rankHeader': 'Rank',
  'ff.collectibity.nameHeader': 'Name',
  'ff.collectibity.itemsCount': 'Items',
  'ff.collectibity.valueScore': 'Value',
  'ff.collectibity.you': 'You',
  'ff.collectibity.yourRankLabel': 'Your Rank',

  // Skill Combos
  'ff.skillCombos.title': 'Skill Combos',
  'ff.skillCombos.tabBR': 'Battle Royale',
  'ff.skillCombos.tabCS': 'Clash Squad',
  'ff.skillCombos.recentPlaystyle': 'Your Recent Playstyle',
  'ff.skillCombos.favoriteRole': 'Favorite Role',
  'ff.skillCombos.longRange': 'Long-Range',
  'ff.skillCombos.shortRange': 'Short-Range',
  'ff.skillCombos.currentCombo': 'Current Combo',
  'ff.skillCombos.suggested': 'Suggested',
  'ff.skillCombos.allSkills': 'All skills',
  'ff.skillCombos.passiveOnly': 'Passive only',
  'ff.skillCombos.comboFilters': 'Combo Filters',
  'ff.skillCombos.character': 'Character',
  'ff.skillCombos.matchMode': 'Match Mode',
  'ff.skillCombos.matchAll': 'Match all',
  'ff.skillCombos.matchAny': 'Match any',
  'ff.skillCombos.searchCharacter': 'Search by character name',
  'ff.skillCombos.noCharactersFound': 'Nothing found',
  'ff.skillCombos.role': 'Role',
  'ff.skillCombos.hasActiveSkill': 'Has active skill',
  'ff.skillCombos.yes': 'Yes',
  'ff.skillCombos.no': 'No',
  'ff.skillCombos.difficulty': 'Difficulty',
  'ff.skillCombos.teamSize': 'Team size',
  'ff.skillCombos.topCombosBR': 'Top Combos - Battle Royale',
  'ff.skillCombos.topCombosCS': 'Top Combos - Clash Squad',
  'ff.skillCombos.updatedEveryPatch': 'Updated every patch',
  'ff.skillCombos.comboName': 'Combo Name',
  'ff.skillCombos.comboDetails': 'Combo Details',
  'ff.skillCombos.usage': 'Usage',
  'ff.skillCombos.brTop': 'BR Top',
  'ff.skillCombos.csBooyah': 'CS Booyah',
  'ff.skillCombos.winRate': 'Win Rate',
  'ff.skillCombos.noResults': 'No combos found',
  'ff.skillCombos.noMore': 'No more combos',
  'ff.skillCombos.faqTitle': 'Skill System',
  'ff.skillCombos.faqSlots': 'Each player has 4 skill slots',
  'ff.skillCombos.faqOption1Title': '1 Active + 3 Passive',
  'ff.skillCombos.faqOption2Title': '4 Passive',
  'ff.skillCombos.faqTip': 'Beginners should start with 1 Active + 3 Passive.',
  'ff.skillCombos.comboFaqTitle': 'FAQ',
  'ff.skillCombos.faqHtml': '<p>Combos are grouped by win rate across the 4 equipped skill slots. Filter by role, difficulty, or whether an active skill is required to find combos that match your playstyle.</p>',

  // Characters
  'ff.characters.title': 'Characters',
  'ff.nav.characters': 'Characters',
  'ff.characters.tabActive': 'Active',
  'ff.characters.tabPassive': 'Passive',
  'ff.characters.filter': 'Filter',
  'ff.characters.sort': 'Sort',
  'ff.characters.searchPlaceholder': 'Search characters...',
  'ff.characters.filterRole': 'Role',
  'ff.characters.filterDifficulty': 'Difficulty',
  'ff.characters.resetFilters': 'Reset filters',
  'ff.characters.roleAll': 'All',
  'ff.characters.roleTeam': 'Team',
  'ff.characters.roleSurvival': 'Survival',
  'ff.characters.roleOffense': 'Offense',
  'ff.characters.roleIntel': 'Intel',
  'ff.characters.difficultyEasy': 'Easy',
  'ff.characters.difficultyMedium': 'Medium',
  'ff.characters.difficultyHard': 'Hard',
  'ff.characters.sortBy': 'Sort By',
  'ff.characters.sortNameAZ': 'Name (A→Z)',
  'ff.characters.sortNameZA': 'Name (Z→A)',
  'ff.characters.sortDifficultyEH': 'Difficulty (Easy→Hard)',
  'ff.characters.sortDifficultyHE': 'Difficulty (Hard→Easy)',
  'ff.characters.sortTopRateHL': 'Top Rate (High→Low)',
  'ff.characters.sortPickRateHL': 'Pick Rate (High→Low)',
  'ff.characters.brTopRate': 'BR Top Rate',
  'ff.characters.pickRate': 'Pick Rate',
  'ff.characters.skillType.active': 'Active',
  'ff.characters.skillType.passive': 'Passive',
  'ff.characters.top3Pairings': 'Top 3 Pairings',
  'ff.characters.top10Synergy': 'Top 10 Synergy',
  'ff.characters.synergySkill': 'Skill',
  'ff.characters.synergyBRTop': 'BR Top',
  'ff.characters.synergyCSTop': 'Top CS',
  'ff.characters.metricBR': 'BR',
  'ff.characters.metricCS': 'CS',
  'ff.characters.synergyPickRate': 'Pick Rate',
  'ff.characters.noResults': 'No characters found',

  // Report
  'ff.report.title': 'Report Item',
  'ff.report.description': 'Please select the reason(s) for reporting this item.',
  'ff.report.categoryLabel': 'Report reason',
  'ff.report.contentLabel': 'Additional details',
  'ff.report.contentPlaceholder': 'Describe the issue in more detail (optional)...',
  'ff.report.submit': 'Submit Report',
  'ff.report.submitSuccess': 'Report submitted successfully',
  'ff.report.submitError': 'Failed to submit report',
  'ff.report.categoryLimit': 'You can select up to 3 reasons',
}